module.exports = __webpack_public_path__ + "static/media/sample-chinese-resident-card-front.db7725b5.png";